<template>
  <div>
    <HelpTip v-bind="labelInfo"></HelpTip>
    <van-field
      class="input work-temp-form-item"
      v-model="formData[id]"
      :name="id"
      :clearable="true"
      :rules="[
        {
          required: required,
          message: `${languages.smartOrderPleaseInpt} ${label}`
        }
      ]"
      :placeholder="placeholder || ''"
      maxlength="600"
      @input="checkWordLimit"
    >
    </van-field>
  </div>
</template>

<script>
import workTemp from '@mixins/officialSupport/workTemp';
import { Toast } from 'vant';
import globalConfig from '@utiles/globalConfig';
import { fieldType } from '@configs/officialSupport/workTemp';
import { mapState } from 'vuex';
export default {
  name: 'TempInput',
  mixins: [workTemp],
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapState({
      loginAccount: state => state.loginAccount
    })
  },
  created() {
    if (this.type == fieldType.roleName) {
      this.initRoleName();
    }
    if (this.type == fieldType.account) {
      this.initAccount();
    }
  },
  methods: {
    checkWordLimit(value) {
      if (value.length == 600) {
        Toast(this.languages.wordLengthTip);
      }
    },
    initRoleName() {
      const roleName = globalConfig.getHrefParam('roleName') || '';
      if (roleName) {
        this.formData[this.id] = roleName;
      }
    },
    initAccount() {
      const loginAccount =
        globalConfig.getHrefParam('loginAccount') || this.loginAccount;
      if (loginAccount) {
        this.formData[this.id] = loginAccount;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
.input {
  ::v-deep .van-field__value {
    position: relative;
    font-size: 16px;
    color: var(--text-color);
  }
  ::v-deep .van-field__body {
    width: 100%;
    height: 64px;
    padding: 0 17px 0 20px;
    background-color: var(--block-bg-light-color);
    border-radius: var(--border-radius);
    box-sizing: border-box;
    border: 1px solid var(--border-color);
    color: var(--text-color);
  }
  ::v-deep .van-field__control {
    font-size: inherit;
    color: inherit;
  }

  .placeholder-style {
    color: var(--placeholder-color) !important;
  }
}
</style>
